export default __webpack_public_path__ + "static/media/nft_icon2.69ed19d4.png";